import { Tooltip } from '@chakra-ui/react';
import { CellProps } from '../../../types';
import styled from '@emotion/styled';
import { OverflowedText } from '../../../../../../utilities/overflowedText';
import { useState } from 'react';

export const Names = ({ cellProps }: { cellProps: CellProps }) => {
  const [isTooltipVisible, setIsTooltipVisible] = useState<boolean>(false);
  const names = [cellProps.row.given_name, cellProps.row.surname].filter(Boolean);
  return (
    <Tooltip isDisabled={!isTooltipVisible} hasArrow placement="bottom-start" label={names.join(' ')}>
      <Container>
        <OverflowedText theme={{ lineHeight: 24, lines: 1 }} overflowedHandler={setIsTooltipVisible}>
          <NamesContainer className="namesContainer">{names.join(' ')}</NamesContainer>
        </OverflowedText>
      </Container>
    </Tooltip>
  );
};

const NamesContainer = styled.div`
  line-height: var(--ds-lineHeights-6);
  letter-spacing: var(--ds-letterSpacings-tight);
  color: var(--ds-colors-blue-600);
  font-weight: var(--ds-fontWeights-medium);
  font-size: var(--ds-fontSizes-md);
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
  justify-content: start;
`;
